module.exports = __webpack_public_path__ + "static/media/camera-alt.be6e5461.svg";